<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <base-card
                        title="Assign KPI to Employee"
                        :v-card-text-class="'pa-0'"

                        :loading-allowed="false"
                    >
<v-row class="py-2 no-gutters justify-space-around">
                                            <v-col cols="12">
                                                <v-card variant="outlined" class="ma-2">
                                                    <div class="d-flex justify-space-between pl-3 pt-3">
                                                        <div>
                                                            <div class="text-subtitle-1 font-weight-medium mb-2">Select KPIs</div>
                                                            <div class="text-caption text-medium-emphasis mb-3">
                                                                Select one or more KPIs from the table below. The selected KPI IDs will be submitted as an array.
                                                            </div>
                                                        </div>

                                                        <v-col cols="4">
                                                            <v-autocomplete
                                                                label="Select Employee"
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                class="px-2"
                                                                v-model="employee_id.value.value"
                                                                :error-messages="employee_id.errorMessage.value"
                                                                clearable
                                                                :disabled="isEntryMode"
                                                                :items="getHrmEmployeeList"
                                                                :item-title="item => `${item.name}-(${item.code})` ?? 'N/A'"
                                                                autocomplete="off"
                                                                @update:model-value="onEmployeeChange"
                                                                item-value="id"
                                                                :loading="employeeLoading"

                                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                                                        </v-col>
                                                    </div>

                                                    <v-row class="pb-2">
                                                        <v-col md="4" cols="12">
                                                            <v-text-field
                                                                v-model="search"
                                                                append-inner-icon="mdi-magnify"
                                                                label="Search"
                                                                single-line
                                                                hide-details
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                class="pl-2"
                                                                clearable
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>

                                                    <v-data-table
                                                        :headers="kpiHeaders"
                                                        v-model="kpi"
                                                        :items="getHrmEmployeeKpisList"
                                                        :loading="employeeKpiLoading"
                                                        item-value="id"
                                                        :search="search"
                                                        show-select
                                                        dense
                                                        class="elevation-0"
                                                        :return-object="true"
                                                    >
                        <template v-slot:loader>
                            <v-progress-linear
                                :color="employeeKpiLoading"
                                height="3"
                                indeterminate
                            />
                        </template>
                                                        <template #item.name="{ item }">
                                                            <div class="font-weight-medium">{{ item.name }}</div>
                                                        </template>
                                                        <template #item.weight="{ item }">
                                                            <!--
                                                                @click.stop and @mousedown.stop are critical here:
                                                                without them, interacting with the input bubbles up
                                                                and toggles the row's checkbox/selection state.
                                                            -->
                                                            <v-text-field
                                                                type="number"
                                                                v-model="item.weight"
                                                                hide-details
                                                                variant="outlined"
                                                                density="compact"
                                                                hide-spin-buttons
                                                                @click.stop
                                                                @mousedown.stop
                                                                @wheel.prevent
                                                            ></v-text-field>
                                                        </template>
                                                        <template #item.frequency="{ item }">
                                                            {{ item.frequency }}
                                                        </template>
                                                    </v-data-table>
                                                </v-card>
                                            </v-col>
                                        </v-row>

                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-row class="pt-2">
                                                <!-- <v-col cols="8">
                                                    <v-textarea
                                                        label="Remarks"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="remarks.value.value"
                                                        :error-messages="remarks.errorMessage.value"
                                                        autocomplete="off"
                                                        rows="3"
                                                        clearable
                                                    ></v-textarea>
                                                </v-col> -->
                                                <v-col cols="12">
                                                    <v-layout class="justify-end">
                                                        <v-btn
                                                            class="bg-grey-darken-1 me-2"
                                                            variant="flat"
                                                            @click="submitForm(0)"
                                                        >DRAFT</v-btn>
                                                        <v-btn
                                                            class="bg-primary"
                                                            variant="flat"
                                                            @click="submitForm(1)"
                                                        >POST</v-btn>
                                                    </v-layout>
                                                </v-col>
                                            </v-row>
                                        </v-card-actions>
                    </base-card>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import BaseCard from '@/components/utils/baseCard.vue';

import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router';


export default {
    components: {
        BaseCard,},
    data: () => ({
        itemsPerPage: 10,
        loading: false,
        employeeLoading: false,
        employeeKpiLoading: false,
        disable_field: true,
        search: "",
        data: {},
        isEntryMode: true,
        kpiHeaders: [
            { title: 'Id', key: 'id', sortable: true },
            { title: 'Code', key: 'code', sortable: true },
            { title: 'Name', key: 'name', sortable: true },
            { title: 'Weight', key: 'weight', sortable: true },
            { title: 'Frequency', key: 'frequency', sortable: true },
        ],
    }),
    watch: {
        kpi: {
            deep: true,
            handler(newValue) {
                // console.log("KPI changed:", newValue);
            }
        },
        "employee_id.value.value": {
            deep: true,
            handler(newVal) {
                this.onEmployeeChange(newVal);
            }
        }
    },
    created() {
        // if (this.$store.getters.getHrmEmployeeList.length == 0) {
            this.employeeLoading = 'blue-darken-3';
            this.$store.dispatch('getHrmEmployeeList').then((response) => {
                this.employeeLoading = false;
            })
        // };

        this.employeeKpiLoading = 'blue-darken-3';
        this.$store.dispatch('getHrmEmployeeKpisList', { type: 'employee' }).then((response) => {
            this.employeeKpiLoading = false;
        })

    },
    computed: {
        getHrmEmployeeList() {
            let data = this.$store.getters.getHrmEmployeeList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        getHrmEmployeeKpisList() {
            let data = this.$store.getters.getHrmEmployeeKpisList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    methods: {
        resetForm() {
            this.data = {};
            this.kpi.value.value = [];
        },
        updateWeight(item, weight) {
            item.weight = weight;
        },
        populateKpiSelectionFromDetails(kpiDetails) {

            if (!Array.isArray(kpiDetails) || kpiDetails.length === 0) {
                this.kpi = [];
                return;
            }

            const masterList = this.getHrmEmployeeKpisList;
            if (masterList.length === 0) {
                return;
            }

            const matchedRows = [];
            kpiDetails.forEach((saved) => {
                const kpiId = saved?.kpi_id;
                const masterItem = masterList.find((m) => String(m?.id) === String(kpiId));

                if (masterItem) {
                    masterItem['weight'] = saved?.weight;

                    const idExists = this.kpi.some(obj => obj?.id === masterItem?.id);
                    matchedRows.push(masterItem);
                }
            });

            this.kpi = matchedRows;
        },

        onEmployeeChange(employeeId) {
            if (!employeeId) {
                this.kpi = [];
                return;
            }

            this.kpi = [];

            this.$store.dispatch("getEmployeeDetailsById", employeeId)
                .then((res) => {
                    console.log(res?.data?.data?.kpi_details)
                    this.populateKpiSelectionFromDetails(res?.data?.data?.kpi_details || []);
                })
                .catch(() => {
                    this.kpi = [];
                });
        },
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                employee_id: yup.string().required().label('Employee'),
                remarks: yup.string().nullable().label("Remarks")
            }),
        });

        const type = useField('type');
        const kpi_details = useField('kpi_details');
        const employee_id = useField('employee_id');
        const remarks = useField('remarks');
        const status = useField('status');

        const kpi = ref([]);

        const errorMessages = ref('');
        const loading = ref('');

        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.type = 'employee';

            // Selected rows are the actual objects from the table (return-object),
            // each carrying its own weight (edited inline via v-model="item.weight").
            values.kpi_details = (kpi.value || []).map((item) => ({
                kpi_id: item.id,
                weight: item.weight,
            }));

            loading.value = 'blue-darken-3';
            store.dispatch("saveHrmEmployeeKpiAssignment", values)
                .then((response) => {
                    resetForm();
                    kpi.value = [];
                    loading.value = false;
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "assign-employee-kpi-records" });
                    }, 2000);
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error.response.data.message);
                })
        })
        return {
            submit,
            submitForm,
            type,
            kpi,
            kpi_details,
            employee_id,
            status,
            remarks,
            errorMessages,
            resetForm,
            loading,
        }
    },
    mounted() {
        if (this.$store.getters.getEditingHrmEmployeeKpiAssignment) {
            const data = this.$store.getters.getEditingHrmEmployeeKpiAssignment;
            this.$store.commit('SET_LOADING', { color: 'blue-darken-3' });

            this.isEntryMode = false;
            this.type.value.value = 'employee';

            this.employee_id.value.value = data?.id;
            this.remarks.value.value = data?.remarks;

            this.$store.commit('UNSET_LOADING');
        } else {
            this.isEntryMode = false
            this.type.value.value = null;
            this.employee_id.value.value = null;
            this.remarks.value.value = null;
            this.kpi_details.value.value = null;
        }
    },
    beforeUnmount() {
        this.$store.commit('UNSET_EDITING_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST');
        this.$store.commit('UNSET_HRM_EMPLOYEE_KPI_ASSIGNMENT_LIST');
    }
}
</script>